import { saleExpired } from '@libs/core';

import { useProduct } from '@/entities/product';

export const useAfterpay = () => {
    const { product } = useProduct();

    const sku = product?.sku;
    const { original, sale, saleValidUntil } = product?.price ?? {};

    const isOnSale = typeof sale === 'number' && !saleExpired(saleValidUntil);
    const displayPrice = isOnSale ? sale : original;

    if (!sku || !displayPrice) {
        return null;
    }

    const isEligible = displayPrice >= 1 && displayPrice <= 2000;

    return {
        sku: sku,
        price: displayPrice,
        primaryCategoryName: product.primaryCategory?.name,
        isEligible,
    };
};
